import { render } from "./IconInvestedRoundedType2.vue?vue&type=template&id=5769c1df&ts=true"
import script from "./IconInvestedRoundedType2.vue?vue&type=script&lang=ts"
export * from "./IconInvestedRoundedType2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__